export default {
    methods: {
        successMessage(msg) {
            this.$message({
                message: msg?msg:'注册成功',
                center: true,
                duration:1000,
                type:"success",
            });
        },
        errorMessage(msg) {
            this.$message({
                message: msg,
                duration:3000,
                center: true
            });
        }
    }
};